<template>
  <div class="user-menu">
    <div class="user-menu-head">
      <img class="avatar" v-if="!userInfo.avatar" src="../../assets/images/icons/avatar.png" />
      <img class="avatar" v-else :src="userInfo.avatar" />
      <div class="profile">
        <div class="profile-name" v-if="userInfo.name">{{userInfo.name}}</div>
        <div class="profile-name" v-else>未设置姓名</div>
        <div class="profile-phone">{{userInfo.phone}}</div>
        <div class="profile-edit">
          <el-button type="text" size="mini" icon="el-icon-edit" @click="$router.push({name: 'profile'})">编辑资料</el-button>
        </div>
      </div>
      
    </div>
    <div class="user-menu-list">
      <div class="menu-item">
        <div class="menu-item-title">
          <i class="el-icon-s-order"></i>
          资源管理
        </div>
        <div class="menu-item-list">
          <div class="menu-sub-item">
            <router-link :to="{name: 'assets-push'}">发布资源</router-link>
          </div>
          <div class="menu-sub-item">
            <router-link :to="{name: 'assets-list', query: {type: 1}}">我的需求</router-link>
          </div>
          <div class="menu-sub-item">
            <router-link :to="{name: 'assets-list', query: {type: 2}}">我的资源</router-link>
          </div>
        </div>
      </div>
      <div class="menu-item">
        <div class="menu-item-title">
          <i class="el-icon-user-solid"></i>
          账号管理
        </div>
        <div class="menu-item-list">
          <div class="menu-sub-item">
            <router-link :to="{name: 'profile'}">个人资料</router-link>
          </div>
          <div class="menu-sub-item">
            <router-link :to="{name: 'password'}">密码修改</router-link>
          </div>
        </div>
      </div>
      <div class="menu-item btn-logout" @click="onLogout">
        退出登陆
      </div>
    </div>
  </div>
</template>

<script>
import { logout } from '@/api/auth'
import commonMixin from '@/mixin/common'
import { getItemObject } from '@/utils/storage'
export default {
  name: 'user-menu',
  mixins: [commonMixin],
  computed: {
    userInfo: {
      get() {
        let user = getItemObject('user-info')
        if (user) {
          return user
        } else {
          return {}
        }
      }
    }
  },
  methods: {
    onLogout() {
      logout().then(res => {
        if (res.code === 200) {
          this.success('退出登陆成功')
          setTimeout(() => {
            this.$router.push({name: 'login'})
          }, 1000)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.user-menu {
  width: 280px;
  background-color: #fcfcfc;
  border: 1px solid #ddd;
  .user-menu-head {
    padding: 15px 20px;
    border-bottom: 1px solid #ddd;
    display: flex;
    flex-direction: row;
    align-items: center;
    .avatar {
      width: 100px;
      height: 100px;
    }
    .profile {
      padding-left: 15px;
      .profile-name {
        font-size: 16px;
        font-weight: bold;
        color: $black;
      }
      .profile-phone {
        margin-top: 8px;
        font-size: 14px;
        color: $grey;
      }
      .profile-edit {

      }
    }
  }
  .user-menu-list {
    padding: 0 0 20px 20px;
    color: $black;
    a {
      color: $black;
      text-decoration: none;
    }
    .btn-logout {
      cursor: pointer;
    }
    .menu-item {
      margin-top: 20px;
      .menu-item-title {
        font-size: 18px;
      }
      .menu-item-list {
        padding-left: 20px;
        .menu-sub-item {
          margin-top: 20px;
          font-size: 14px;
          color: $grey-deep;
        }
      }
    }
  }
}
</style>